import React from 'react'
import { Alert } from '@ztechapps/webui.util'

export const Layout = () => {
  return (
    <Alert>
      <h1>Reports Page here</h1>
    </Alert>
  )
}
